module.exports = __webpack_public_path__ + "static/media/hu.b95aa09e.svg";